import { SearchContainer } from "@Components/forecast/search/SearchContainer";
import { SENTRY_CONSENT_UC_ID } from "@Constants/consentManagement";
import { useConsentManagement } from "@Hooks/useConsentManagement";
import { enableOrDisableSentryBasedOnConsent } from "@Utils/sentry";
import { lazy, Suspense, useEffect } from "react";

const ForecastDebugTools = lazy(() =>
  import("@Components/debug/ForecastDebugTools").then((module) => ({
    default: module.ForecastDebugTools,
  })),
);

type SearchAppProps = {
  devMode: boolean;
};

export const SearchApp = ({ devMode }: SearchAppProps) => {
  const { initialised: sentryConsentInitialised, active: sentryConsentActive } =
    useConsentManagement(SENTRY_CONSENT_UC_ID);

  useEffect(() => {
    enableOrDisableSentryBasedOnConsent(
      sentryConsentInitialised,
      sentryConsentActive,
    );
  }, [sentryConsentInitialised, sentryConsentActive]);

  return (
    <>
      {devMode && (
        <Suspense fallback={null}>
          <ForecastDebugTools isSearchOnly />
        </Suspense>
      )}

      <div className="m:xl:mx-2">
        <SearchContainer />
      </div>
    </>
  );
};
